export const config = (theirMonthOffer, discountDuration) => ({
  youGetTitle: 'You get',
  yourFriendGetsTitle: 'Your friend gets',
  youGetDescription: 'when your friend gets their first box',
  yourFriendGetsDescription: `off their first box + ${theirMonthOffer} off their first ${discountDuration}`,
})
